import React, { useMemo } from "react";
import { copyToClipboard } from "@/src/components/common/common";
import Iconify from "@/src/components/iconify";
import DashboardLayout from "@/src/components/layout";
import Progressbar from "@/src/components/loading";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import IconCode from "@/src/lib/iconCode";

import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import CustomIconButton from "@/src/lib/ui/iconButton";
import CustomTooltip from "@/src/lib/ui/customTooltip";

Offers.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

export default function Offers({ data }) {
    const { data: couponData, isLoading } = useCustomQuery(
        "coupon_list",
        cartApiService.getCouponLists
    );

    const couponList = useMemo(() => {
        return couponData?.data?.data || [];
    }, [couponData]);

    // const couponList = couponData?.data?.data || [];

    if (isLoading) {
        return (
            <div className="flex flex-row items-center justify-center w-full h-full">
                <Progressbar />
            </div>
        );
    }

    return (
        <>
            <div className="max-w-6xl mx-auto px-3 md:px-0">
                <h1 className="text-xl my-5 font-semibold text-center sm:text-left text-black">
                    Online Offers
                </h1>

                {couponList.length ? (
                    couponList.map((coupon) => (
                        <div
                            key={coupon?.coupon_id}
                            className="p-4 border border-solid border-gray-200 my-5 rounded-md bg-white shadow-xs"
                        >
                            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                                <div className="w-full sm:w-2/3">
                                    <h6 className="text-base font-semibold text-primary">
                                        {coupon?.coupon_code}
                                    </h6>
                                    <p className="text-sm font-light text-gray-600 mt-1">
                                        {coupon?.description}
                                    </p>
                                </div>
                                <div className="w-full sm:w-1/3 flex justify-end">
                                    <CustomTooltip
                                        title="Copy Coupon Code"
                                        className="text-primary"
                                    >
                                        <CustomIconButton
                                            size="small"
                                            onClick={() =>
                                                copyToClipboard(
                                                    coupon?.coupon_code
                                                )
                                            }
                                        >
                                            <Iconify
                                                icon={IconCode?.copy}
                                                fontSize="small"
                                                className="text-primary"
                                            />
                                        </CustomIconButton>
                                    </CustomTooltip>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-center text-gray-500 mt-5">
                        No coupons available.
                    </p>
                )}
            </div>
        </>
    );
}

export async function getServerSideProps() {
    return {
        props: {
            data: {
                seoTitle: "Offers & Discounts | House of Diagnostics | HOD",
                seoDescription:
                    "Avail these exclusive online offers on the HOD Website for additional discounts.",
                routerPath: "offers",
            },
        },
    };
}
